module.exports = __webpack_public_path__ + "img/instagram.6dc72026.svg";